import React from 'react';
import chroma from 'chroma-js';

import Graphic from '../Graphic';
import { useTheme } from '../../../hooks/index';

const Variables = props => {
  const { primary } = useTheme();

  return (
    <Graphic
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 140 145"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      {...props}>
      <path
        fill="#F3F3F4"
        d="M70.994 145c28.166 0 51-1.567 51-3.5s-22.834-3.5-51-3.5c-28.167 0-51 1.567-51 3.5s22.833 3.5 51 3.5Z"
      />
      <path
        fill="#D9D9D9"
        d="M70.155 139.214c33.775 0 61.155-27.359 61.155-61.107S103.93 17 70.155 17C36.38 17 9 44.358 9 78.107c0 33.748 27.38 61.107 61.155 61.107Z"
      />
      <path
        fill="#D9D9D9"
        d="M109.723 125.227C99.017 134.434 85.083 140 69.85 140c-17.428 0-33.153-7.284-44.292-18.972l84.165 4.199Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        d="M109.723 125.227C99.017 134.434 85.083 140 69.85 140c-17.428 0-33.153-7.284-44.292-18.972l84.165 4.199Z"
      />
      <path
        fill="#D9D9D9"
        d="M68.492 139.985a37.35 37.35 0 0 0 2.502-13.485 37.352 37.352 0 0 0-3.163-15.086 2.38 2.38 0 0 0-3.128-1.216 2.35 2.35 0 0 0-1.225 3.103 32.673 32.673 0 0 1 2.766 13.199 32.668 32.668 0 0 1-2.755 13.173c1.65.171 3.318.276 5.003.312Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M68.492 139.985a37.35 37.35 0 0 0 2.502-13.485 37.352 37.352 0 0 0-3.163-15.086 2.38 2.38 0 0 0-3.128-1.216 2.35 2.35 0 0 0-1.225 3.103 32.673 32.673 0 0 1 2.766 13.199 32.668 32.668 0 0 1-2.755 13.173c1.65.171 3.318.276 5.003.312Z"
      />
      <path
        fill="#D9D9D9"
        d="M47.058 135.615a7.138 7.138 0 0 0 3.466-2.341l.778-.965.264.656a4.751 4.751 0 0 0 4.41 2.963h.768a2.366 2.366 0 0 0 2.375-2.357 2.368 2.368 0 0 0-2.375-2.357h-.767l-1.264-3.136 2.46-3.05a2.374 2.374 0 0 1 1.854-.885h.092a2.366 2.366 0 0 0 2.375-2.357 2.368 2.368 0 0 0-2.375-2.357h-.092a7.149 7.149 0 0 0-5.564 2.654l-.778.965-.264-.656a4.752 4.752 0 0 0-4.41-2.963h-.767a2.366 2.366 0 0 0-2.375 2.357 2.366 2.366 0 0 0 2.375 2.357h.767l1.264 3.136-2.46 3.05a2.375 2.375 0 0 1-1.854.885h-.092a2.366 2.366 0 0 0-2.375 2.346 60.76 60.76 0 0 0 4.564 2.055Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M47.058 135.615a7.138 7.138 0 0 0 3.466-2.341l.778-.965.264.656a4.751 4.751 0 0 0 4.41 2.963h.768a2.366 2.366 0 0 0 2.375-2.357 2.368 2.368 0 0 0-2.375-2.357h-.767l-1.264-3.136 2.46-3.05a2.374 2.374 0 0 1 1.854-.885h.092a2.366 2.366 0 0 0 2.375-2.357 2.368 2.368 0 0 0-2.375-2.357h-.092a7.149 7.149 0 0 0-5.564 2.654l-.778.965-.264-.656a4.752 4.752 0 0 0-4.41-2.963h-.767a2.366 2.366 0 0 0-2.375 2.357 2.366 2.366 0 0 0 2.375 2.357h.767l1.264 3.136-2.46 3.05a2.375 2.375 0 0 1-1.854.885h-.092a2.366 2.366 0 0 0-2.375 2.346 60.76 60.76 0 0 0 4.564 2.055Z"
      />
      <path
        fill="#D9D9D9"
        d="M38.065 131.109a33.089 33.089 0 0 1-.32-4.609 32.671 32.671 0 0 1 2.764-13.199 2.35 2.35 0 0 0-1.225-3.103 2.38 2.38 0 0 0-3.127 1.216 37.352 37.352 0 0 0-3.163 15.086c0 .391.005.783.017 1.173a61.524 61.524 0 0 0 5.054 3.436Z"
      />
      <path
        fill={primary}
        fillOpacity=".5"
        d="M38.065 131.109a33.089 33.089 0 0 1-.32-4.609 32.671 32.671 0 0 1 2.764-13.199 2.35 2.35 0 0 0-1.225-3.103 2.38 2.38 0 0 0-3.127 1.216 37.352 37.352 0 0 0-3.163 15.086c0 .391.005.783.017 1.173a61.524 61.524 0 0 0 5.054 3.436Z"
      />
      <path
        fill={primary}
        fillOpacity=".75"
        fillRule="evenodd"
        d="M110.817 124.854c.279-.248.556-.497.83-.748a.5.5 0 1 0-.676-.737c-.54.495-1.089.981-1.646 1.457a.496.496 0 0 0-.186.343.496.496 0 0 0 .467.547.506.506 0 0 0 .368-.13c.283-.241.564-.485.843-.732Zm3.274-4.556a.507.507 0 0 0-.106.555.493.493 0 0 0 .283.268.49.49 0 0 0 .39-.017.5.5 0 0 0 .159-.119 61.766 61.766 0 0 0 4.316-5.089.501.501 0 0 0-.797-.605 60.844 60.844 0 0 1-4.245 5.007Zm-9.417 9.343a.504.504 0 0 0 .209-.32.474.474 0 0 0-.002-.195.487.487 0 0 0-.215-.317.498.498 0 0 0-.377-.07.49.49 0 0 0-.179.076 60.716 60.716 0 0 1-3.7 2.336.499.499 0 0 0 .123.916.5.5 0 0 0 .38-.051 61.929 61.929 0 0 0 3.761-2.375Zm-5.706 3.46a.5.5 0 0 0-.472-.882c-18.15 9.695-39.99 9.416-57.774-.37a.49.49 0 0 0-.38-.042.494.494 0 0 0-.359.424.5.5 0 0 0 .256.494c18.08 9.947 40.278 10.232 58.729.376Zm24.138-25.146a.494.494 0 0 0-.043.38.497.497 0 0 0 .62.342.494.494 0 0 0 .299-.239c9.968-18.084 10.274-40.283.434-58.727a.5.5 0 0 0-.883.47c9.68 18.144 9.379 39.983-.427 57.774Zm-.639-59.687a.501.501 0 0 0 .865-.503 60.76 60.76 0 0 0-2.374-3.762.5.5 0 0 0-.826.564 60.066 60.066 0 0 1 2.335 3.7v.001Zm-89.69 79.612a.492.492 0 0 0 .7-.097.49.49 0 0 0 .098-.37.501.501 0 0 0-.193-.33 60.521 60.521 0 0 1-5.007-4.244.498.498 0 0 0-.686.04.5.5 0 0 0-.001.687 61.529 61.529 0 0 0 5.09 4.314Zm-8.211-7.484a.5.5 0 1 0 .737-.676 61.999 61.999 0 0 1-.7-.776C2.462 93.874 4.83 55.586 29.907 33.401c25.076-22.185 63.367-19.87 85.551 5.16.231.263.46.526.686.79a.503.503 0 0 0 .716.069.502.502 0 0 0 .044-.718 61.894 61.894 0 0 0-.655-.755l-.006-.008-.036-.04-.035-.04a62.576 62.576 0 0 0-3.805-3.926.48.48 0 0 0-.065-.073 61.224 61.224 0 0 0-5.09-4.314.495.495 0 0 0-.128-.071 61.195 61.195 0 0 0-7.187-4.653.496.496 0 0 0-.146-.12c-18.08-9.949-40.278-10.234-58.728-.377a.498.498 0 0 0-.22.237 57.12 57.12 0 0 0-1.407.785.498.498 0 0 0-.318.063 61.549 61.549 0 0 0-3.762 2.375.5.5 0 0 0-.195.262 62.219 62.219 0 0 0-4.8 3.673.498.498 0 0 0-.305.12c-.566.483-1.123.977-1.672 1.48a.5.5 0 0 0-.156.288 62.467 62.467 0 0 0-2.724 2.682.499.499 0 0 0-.29.151 61.682 61.682 0 0 0-4.316 5.089.498.498 0 0 0-.102.308 61.228 61.228 0 0 0-4.513 6.935.499.499 0 0 0-.234.215c-9.97 18.084-10.275 40.282-.434 58.727.025.048.058.09.095.125.302.565.613 1.127.934 1.684.012.047.03.093.055.136a61.3 61.3 0 0 0 2.373 3.763.496.496 0 0 0 .076.087 62.091 62.091 0 0 0 4.71 6.056l.036.04.043.048c.22.25.443.497.669.742Z"
        clipRule="evenodd"
      />
      <path fill="#fff" stroke={primary} d="M1 16h88v85H1V16Z" />
      <path fill="#fff" d="M5.994 21h78v76h-78V21Z" />
      <path
        fill="#D9D9D9"
        d="M19.994 21h-13a1 1 0 0 0-1 1v74a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V22a1 1 0 0 0-1-1ZM82.994 30.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 39.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 48.214h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 57.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 66.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM82.994 75.213h-56a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1ZM38.77 21H26.4a.905.905 0 0 0 0 1.81H38.77a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill={primary}
        d="M83.089 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#F3F3F4"
        d="M74.225 21h-5.281a.905.905 0 0 0 0 1.81h5.28a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#D9D9D9"
        d="M33.453 24.619h-7.054a.905.905 0 0 0 0 1.81h7.054a.905.905 0 0 0 0-1.81Z"
      />
      <path
        fill="#fff"
        d="M89.114 113.213c7.403 0 13.404-5.996 13.404-13.393s-6.001-13.393-13.404-13.393S75.71 92.423 75.71 99.82s6.001 13.393 13.404 13.393Z"
      />
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M89.114 113.214c7.403 0 13.404-5.997 13.404-13.394s-6.002-13.393-13.404-13.393c-7.403 0-13.404 5.996-13.404 13.393s6.001 13.394 13.404 13.394Zm1.675-18.416a1.675 1.675 0 0 0-3.35 0v3.348h-3.353a1.675 1.675 0 1 0 0 3.348h3.351v3.349a1.676 1.676 0 0 0 3.351 0v-3.349h3.351a1.674 1.674 0 1 0 0-3.348h-3.35v-3.348Z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M124.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M124.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Z"
      />
      <path
        stroke={primary}
        d="M124.494 23.5c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22 22 9.85 22 22Z"
      />
      <path
        fill="#fff"
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        stroke={primary}
        d="M136.994 69.5h-13a1.5 1.5 0 0 0-1.5 1.5v13a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5V71a1.5 1.5 0 0 0-1.5-1.5Z"
      />
      <path
        fill={primary}
        fillRule="evenodd"
        d="M131.387 73.403c-.227-.937-1.56-.937-1.787 0a.919.919 0 0 1-1.372.568c-.823-.502-1.765.44-1.264 1.263a.922.922 0 0 1-.187 1.178.918.918 0 0 1-.381.195c-.937.227-.937 1.56 0 1.787a.92.92 0 0 1 .568 1.371c-.501.824.441 1.766 1.264 1.264a.92.92 0 0 1 1.372.568c.227.937 1.56.937 1.787 0a.918.918 0 0 1 1.372-.568c.823.502 1.765-.44 1.264-1.263a.928.928 0 0 1 .187-1.178.918.918 0 0 1 .381-.195c.937-.227.937-1.56 0-1.787a.916.916 0 0 1-.631-.541.912.912 0 0 1 .063-.83c.501-.824-.441-1.766-1.264-1.264a.916.916 0 0 1-1.177-.187.919.919 0 0 1-.195-.381Zm-.893 5.897a1.802 1.802 0 0 0 1.273-3.073 1.802 1.802 0 0 0-2.546 0 1.802 1.802 0 0 0 0 2.546c.338.337.796.527 1.273.527Z"
        clipRule="evenodd"
      />
      <path
        fill={primary}
        d="m89.994 14-.514.546a.75.75 0 0 0 .873.112l-.36-.658h.001ZM84.868 3.852a4 4 0 1 0-6.749 4.295 4 4 0 1 0 6.75-4.294l-.001-.001ZM100.994 8l.344-.666a.75.75 0 0 0-.703.008l.359.658Zm15.5 8 .315.68a.746.746 0 0 0 .435-.665.756.756 0 0 0-.406-.682l-.344.667Zm-14 6.5.079.746a.746.746 0 0 0 .236-.066l-.315-.68Zm-14 1.5-.08-.746a.75.75 0 0 0-.668.808l.748-.062Zm1 12-.748.062a.75.75 0 0 0 .93.666L89.494 36Zm16-4 .087-.745a.748.748 0 0 0-.269.017l.182.728Zm20.374-.148a4.008 4.008 0 0 0-2.508-1.78 4 4 0 0 0-4.241 6.075 4 4 0 0 0 6.749-4.295Zm-32.5-20a4 4 0 1 0-6.751 4.296 4 4 0 0 0 6.752-4.296h-.001Zm-8.5-8a4 4 0 1 0-6.749 4.295 4 4 0 1 0 6.75-4.294l-.001-.001ZM116.494 16l.317.68a.747.747 0 0 0 .433-.665.756.756 0 0 0-.406-.682l-.344.667ZM104.37 5.852a4.002 4.002 0 0 0-7.28 1.281 4 4 0 1 0 7.28-1.281Zm1.499 14.5a4.008 4.008 0 0 0-2.508-1.78 4 4 0 1 0 2.508 1.78Zm3 9.5a4.008 4.008 0 0 0-2.508-1.78 4 4 0 1 0 2.508 1.78Zm17.001 2a4.001 4.001 0 1 0-6.75 4.298 4.001 4.001 0 0 0 6.75-4.298ZM90.508 13.454l-8.5-8-1.028 1.092 8.5 8 1.028-1.092Zm10.127-6.112-11 6 .718 1.316 11-6-.718-1.316Zm16.203 7.991-15.5-7.999-.688 1.332 15.5 8 .688-1.333Zm-.66-.013-14 6.5.631 1.36 14-6.5-.631-1.36Zm-27.604 9.426 13.999-1.5-.159-1.492-14 1.5.16 1.492Zm-.828-.684 1 12 1.495-.124-1-12-1.495.124Zm1.93 12.666 16-4-.364-1.456-16 4 .364 1.456Zm15.73-3.983 17 2 .175-1.49-17-2-.175 1.49ZM90.508 13.454l-8.5-8-1.028 1.092 8.5 8 1.028-1.092Zm26.33 1.879-15.5-7.999-.688 1.332 15.5 8 .688-1.333Zm-.66-.013-14 6.5.631 1.36 14.002-6.5-.633-1.36Zm-10.772 17.425 17 2 .175-1.49-17-2-.175 1.49Z"
      />
      <path fill={primary} d="M115.994 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <path
        fill="#fff"
        d="M122.994 39.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M122.994 39.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
      />
      <path
        stroke={primary}
        d="M122.994 39.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
      />
      <path
        fill="#fff"
        d="M80.994 11.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
      />
      <path
        fill={primary}
        fillOpacity=".25"
        d="M80.994 11.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
      />
      <path
        stroke={primary}
        d="M80.994 11.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
      />
      <path fill={primary} d="M89.994 40a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
      <defs>
        <linearGradient
          id="a"
          x1="89.114"
          x2="89.114"
          y1="86.427"
          y2="113.214"
          gradientUnits="userSpaceOnUse">
          <stop stopColor={chroma(primary).brighten(0.5 - 0)} />
          <stop offset="1" stopColor={primary} />
        </linearGradient>
      </defs>
    </Graphic>
  );
};
export default Variables;
